import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
  type: {
    type: String,
    default: 'Button'
  },
  name: {
    type: String,
    default: null
  },
  color: {
    type: String,
    default: '#295fd2'
  },
  tooltip: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  primary: {
    type: Boolean,
    default: false
  },
  icon: {
    type: Boolean,
    default: false
  },
  text: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  large: {
    type: Boolean,
    default: false
  },
  block: {
    type: Boolean,
    default: false
  },
  success: {
    type: Boolean,
    default: false
  },
  danger: {
    type: Boolean,
    default: false
  }
},
  emits: ['action'],
  setup(__props, { emit: __emit }) {


const props = __props

// --------------
// Button Name ==
// --------------

const buttonName = computed(() => {
  return props.icon ? undefined : props.name || props.type
})

// -----------------
// Button Variant ==
// -----------------

const buttonVariant = computed(() => {
  if (props.icon) return 'plain'
  if (props.primary) return 'flat'
  if (props.text || props.type === 'Cancel') return 'text'
  return 'tonal'
})

// --------------
// Button Icon ==
// --------------
const buttonIcon = computed(() => {
  // Use dictionary entry
  return useIconLib(props.type)
})

// --------------
// Button Size ==
// --------------
const buttonSize = props.large ? 'large' : props.small ? 'x-small' : undefined
const buttonHeight = props.large ? '40px' : props.small ? '20px' : '25px'

// ---------------
// Button Color ==
// ---------------
const buttonColor = computed(() => {
  if (props.primary) return 'primary'
  if (props.success) return 'success'
  if (props.danger) return 'error'
  if (props.type === 'Cancel') return '#FF007C'

  return props.color
})

const emit = __emit
function handleClick() {
  if (props.disabled) return
  // Emit action
  emit('action')
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (__props.tooltip)
    ? (_openBlock(), _createBlock(_component_v_tooltip, {
        key: 0,
        text: __props.tooltip,
        "open-delay": "500"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            text: _unref(buttonName),
            color: _unref(buttonColor),
            size: _unref(buttonSize),
            variant: _unref(buttonVariant),
            height: _unref(buttonHeight),
            block: __props.block,
            icon: __props.icon ? _unref(buttonIcon) : undefined,
            "prepend-icon": __props.icon ? undefined: _unref(buttonIcon),
            disabled: __props.disabled,
            loading: __props.loading,
            rounded: "xl",
            class: "hy-button",
            onClick: _withModifiers(handleClick, ["stop","prevent"])
          }), null, 16, ["text", "color", "size", "variant", "height", "block", "icon", "prepend-icon", "disabled", "loading"])
        ]),
        _: 1
      }, 8, ["text"]))
    : (_openBlock(), _createBlock(_component_v_btn, {
        key: 1,
        text: _unref(buttonName),
        color: _unref(buttonColor),
        size: _unref(buttonSize),
        variant: _unref(buttonVariant),
        height: _unref(buttonHeight),
        block: __props.block,
        icon: __props.icon ? _unref(buttonIcon) : undefined,
        "prepend-icon": __props.icon ? undefined: _unref(buttonIcon),
        disabled: __props.disabled,
        loading: __props.loading,
        rounded: "xl",
        class: "hy-button",
        onClick: _withModifiers(handleClick, ["stop","prevent"])
      }, null, 8, ["text", "color", "size", "variant", "height", "block", "icon", "prepend-icon", "disabled", "loading"]))
}
}

})